import { render, staticRenderFns } from "./CatalogueSearchbar.vue?vue&type=template&id=5d813b27"
import script from "./CatalogueSearchbar.vue?vue&type=script&lang=js"
export * from "./CatalogueSearchbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports